(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lecce-dry-goods-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lecce-tabs]').forEach((section) => {
    const tabs = section.querySelectorAll('[data-tab]');
    const panels = section.querySelectorAll('[data-panel]');
    const shopLink = section.querySelector('[data-shop-link]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const name = tab.dataset.tab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          const active = panel.dataset.panel === name;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
          if (active) {
            shopLink.href = panel.dataset.url;
            shopLink.firstChild.textContent = `Shop ${panel.dataset.label} `;
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
